import { React, useEffect } from "react";
import "./babyCare.css";
import {
  heading,
  paragraph,
  parenthood,
  daycare,
  special,
  takeabreak,
  helpingyoudata,
  sleepSpecialists,
  ourselves,
  serviceShowcaseData,
  happyparents,
  babycarehospitals,
  settings,
  truncateLetters,
  settings3,
  toddlercare,
} from "./BabyCareData";
import Header from "../../Header/Header";
import banner from "../../Assets/cover.png";
import babycareimg2 from "../../Assets/babycareimg2.png";
import CardSlider from "../CardSlider";
import ServiceShowcase from "../ServiceShowCase";
import Slider from "react-slick";
import quote from "../../Assets/icon.png";
import ServicesGrid from "../ServiceGrid";
import Footer from "../../Footer/Footer";
import SleepSpecialistsCarousel from "../SleepCarousel/SleepCarousel";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal";
import { useNavigate } from "react-router-dom";

const BabyCare = () => {
 const navigate = useNavigate();

  return (
    <>
      <Header />
      <div>
        <div className="babycare-cover-hero">
          <img className="babycare-cover" src={banner} alt="cover" />
          <h1 className="babycare-cover-title">Baby Care</h1>
        </div>
        <div className="servicesShowCase">
          {serviceShowcaseData.map((service, index) => (
            <ServiceShowcase
              key={index}
              className="baby-care-servicewrapper"
              data={service}
              onServiceClick={() => navigate('/')}

            />
          ))}
        </div>
       
        <h2 className="babycare-expert-care-h2">{heading}</h2>
        <p className="babycare-expert-care-p">{paragraph}</p>
      </div>
      <CardSlider
        heading="Making Parenthood Easier"
        heading2="Newborn Nurturers"
        data={parenthood}
      />
      <div className="sleep-specialist">
        <h2>Sleep Specialists</h2>
        <SleepSpecialistsCarousel data={sleepSpecialists} />
      </div>

      <CardSlider heading="Daycare Assistants" data={daycare} />

      <div className="toddlercare">
        <h2>Toddler Care</h2>
        <div className="toddlercare-grid">
          {toddlercare.map((item, index) => (
            <div
              key={index}
              className={`toddlercare-item ${index === 3 ? "big" : ""}`}
            >
              <img src={item.img} alt={item.title} />
              <p>{item.title}</p>
            </div>
          ))}
        </div>
      </div>

      <CardSlider heading="Special Needs Care" data={special} />
      <CardSlider
        heading="Take A Break, We’ve Got This For You"
        data={takeabreak}
        className="card-slider card-slider-white"
      />

      <div className="helping-you">
        <div className="helping-you-text ">
          <div className="h2-box">
            <h2>{helpingyoudata.heading}</h2>
          </div>
          <p>{helpingyoudata.para}</p>
          <p>{helpingyoudata.para2}</p>
        </div>
        <div className="helping-you-image">
          <img src={helpingyoudata.image} alt="Helping You" />
        </div>
      </div>

      <div className="ourselves">
        <h2>Setting Ourselves Apart</h2>
        <div className="ourselves-grid">
          {Object.entries(ourselves).map(([key, item]) => (
            <div key={key} className="ourselves-card">
              <img src={item.img} alt="image" />
              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>

      <div className="happy-parents">
        <h2>Hear From Happy Parents</h2>

        <Slider {...settings}>
          {happyparents.map((item) => (
            <div
              key={item.id}
              className="testimonial-card blue"
              style={{ backgroundColor: "#f4f4f4" }}
            >
              <img src={quote} alt="quote" className="quote-img" />
              <p className="testimonial-text">
                “{truncateLetters(item.desc, 260)}”
              </p>
              <div className="testimonial-user">
                <img
                  src={item.userimg}
                  alt={item.username}
                  className="user-img"
                />
                <h4 className="user-name">{item.username}</h4>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="care-solutions">
        <h2>Providing Hospital Approved Baby Care Solutions</h2>
        <Slider {...settings3}>
          {babycarehospitals.map((item, index) => (
            <div key={index} className="hospital-card">
              <img src={item.logo} alt={item.name} />
            </div>
          ))}
        </Slider>
      </div>

      <ServicesGrid title="Check Our Other Services" exclude="Baby Care" />
      <Footer />
    </>
  );
};

export default BabyCare;
